import { ComposableMap, Geographies, Geography } from 'react-simple-maps';

export const WorldMap = ({ dashboardCounts }: any) => {
  return (
    <div style={{ width: '100%', maxHeight: '175px' }}>
      <div style={{ width: '100%', maxHeight: '175px' }}>
        <ComposableMap style={{ width: '100%', height: '200px' }}>
          <Geographies geography="/features.json">
            {({ geographies }) =>
              geographies.map((geo: any) => {
                const countryName = geo.properties.name;
                const isIndia = countryName === 'India';
                const isOtherCountry = dashboardCounts.countriesCount.otherCountriesCount.some(
                  (item: any) => item.countryName === countryName,
                );

                // Determine the color based on conditions
                const fillColor =
                  isIndia && dashboardCounts.countriesCount.indianCountryCount > 0
                    ? '#4776E6'
                    : isOtherCountry && dashboardCounts.countriesCount.totalOtherCountriesCount > 0
                      ? '#062EC6'
                      : 'white';

                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    style={{
                      default: {
                        fill: fillColor,
                        stroke: '#CECECE',
                        strokeWidth: 1,
                        outline: '#CECECE',
                      },
                      hover: {
                        fill: '#D4DFF9',
                        outline: '#4776E6',
                      },
                      pressed: {  // Add a pressed style
                        fill: '#D4DFF9',
                        outline: '#4776E6',
                      },
                    }}
                  />
                );
              })
            }
          </Geographies>
        </ComposableMap>
      </div>
    </div>
  );
};